import API from "../../models/API";
import { AcceleratorBatchStore } from "../../stores/impl/AcceleratorBatchStore";
import { CheckoutRecord } from "../../types/locks/CheckoutRecord";
import { LockData } from "../../types/locks/LockData";

export {
  getLockedBatches,
  updateLockedBatches,
  getBatchLockInformation,
  unlockBatch,
  lockBatch,
};

async function getBatchLockInformation(
  batchUuid: string,
  batchClassId: string,
): Promise<CheckoutRecord | undefined> {
  return await API.get(`/v0/lock/batch/${batchUuid}`, { batchClassId })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Batch not locked");
      }
      return res.json() as Promise<CheckoutRecord>;
    })
    .catch((err) => {
      console.error("Could not get lock info for batches", err);
      return undefined;
    });
}

/**
 * Get locked AcceleratorBatches for a BC ID.
 * @param batchClassId
 * @returns undefined if request failed, otherwise `{ batchUuid: lockedUser }`
 */
async function getLockedBatches(batchClassId: string) {
  // get list of updated lock info,
  return await API.get("/v0/lock/batch", { batchClassId })
    .then((res) => {
      if (!res.ok) {
        throw new Error("API did not respond correctly.");
      }
      return res.json() as Promise<CheckoutRecord[]>;
    })
    .catch((err) => {
      console.error("Could not get lock info for batches", err);
      return undefined;
    });
}

async function unlockBatch(batchUuid: string, batchClassId: string) {
  return API.delete(`/v0/lock/batch/${batchUuid}`, { batchClassId })
    .then((res) => {
      return res.ok;
    })
    .catch((err) => {
      console.error(
        `API did not respond correctly when unlocking Batch [${batchUuid}:${batchClassId}]`,
        err,
      );
      return false;
    });
}

async function lockBatch(batchUuid: string, batchClassId: string) {
  return API.post(`/v0/lock/batch/${batchUuid}`, { batchClassId })
    .then((res) => {
      return res.ok;
    })
    .catch((err) => {
      console.error(
        `API did not respond correctly when locking Batch [${batchUuid}:${batchClassId}]`,
        err,
      );
      return false;
    });
}

/**
 * Populate
 * @param batchClassId
 * @returns undefined if request failed, otherwise `{ modelUuid: lockedUser }`
 */
// TODO: determine if this can be deleted
function updateLockedBatches(
  lockedBatches: LockData,
  acceleratorBatchStore: typeof AcceleratorBatchStore,
) {
  console.table(lockedBatches);
  const lockedBatchesUuids = Object.keys(lockedBatches);
  lockedBatchesUuids.forEach((key) => {
    const batch = acceleratorBatchStore.getWithoutLookup(key);
    if (batch) {
      batch.lock(lockedBatches[key]);
    }
  });
  acceleratorBatchStore
    .getAll()
    .filter((x) => lockedBatchesUuids.includes(x.uuid))
    .forEach((x) => x.unlock());
}
